// Catégories de la carte routière CALTRAC (P3) — MÊMES clés/libellés/couleurs que le backend
// (road_speed.CATEGORY_META). Distinction HONNÊTE : VMA confirmée (officielle) vs limite OSM
// indicative (non officielle) vs vitesse supposée vs sans limite vs GPS seul vs échangeur ambigu.
export const CATEGORY_META = {
  vma: { label: "VMA confirmée (limite respectée)", color: "#10B981" },
  vma_over: { label: "Dépassement de VMA confirmée", color: "#EF4444" },
  osm: { label: "Limite indicative OSM (non officielle)", color: "#3B82F6" },
  vs: { label: "Vitesse supposée (théorique, non réglementaire)", color: "#F59E0B" },
  no_limit: { label: "Tronçon sans limite connue", color: "#94A3B8" },
  gps_only: { label: "Hors réseau cartographié — GPS seul, moins fiable", color: "#64748B" },
  ambiguous: { label: "Échangeur / ambigu — non analysé", color: "#A855F7" },
  unsupported: { label: "Limite non interprétable", color: "#6B7280" },
};

// Ordre de sévérité pour le rendu : les dépassements et zones ambiguës sont dessinés AU-DESSUS.
export const RENDER_ORDER = { vma_over: 3, ambiguous: 2 };

export const catColor = (k) => (CATEGORY_META[k] || CATEGORY_META.gps_only).color;
export const catLabel = (k) => (CATEGORY_META[k] || CATEGORY_META.gps_only).label;
